import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae0287b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "package-card--title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "pt-2 mt-3 card-card-blocks card-padding-x" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "secondary-text" }, " Select at least 1 carrier to include it to this Plan. ", -1))
const _hoisted_6 = { class: "plan-carriers-list pt-4 pb-5" }
const _hoisted_7 = { class: "secondary-text" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = { class: "col-2 d-flex justify-content-end" }
const _hoisted_11 = { class: "pb-5 mt-3 card-card-blocks card-padding-x" }
const _hoisted_12 = ["for"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "FREE Socials", -1))
const _hoisted_14 = { class: "pb-5 mt-3 card-card-blocks card-padding-x" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1))
const _hoisted_16 = { class: "pb-5 mt-3 card-card-blocks card-padding-x" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1))
const _hoisted_18 = { class: "pb-5 mt-3 card-card-blocks card-padding-x" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSwitch = _resolveComponent("AppSwitch")!
  const _component_Partner = _resolveComponent("Partner")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppSelectInput = _resolveComponent("AppSelectInput")!
  const _component_AppTabs = _resolveComponent("AppTabs")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: null }, {
    "tabs-title": _withCtx(() => [
      _createElementVNode("label", {
        for: _ctx.id,
        class: "d-flex align-items-center justify-content-between"
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createVNode(_component_AppSwitch, {
          id: _ctx.id,
          modelValue: _ctx.isChecked,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isChecked) = $event))
        }, null, 8, ["id", "modelValue"])
      ], 8, _hoisted_1)
    ]),
    tabs: _withCtx(() => [
      (_ctx.isChecked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AppTabs, {
              modelValue: _ctx.selectedTab,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTab) = $event)),
              "is-margin": true,
              tabs: _ctx.getTabs
            }, {
              "tabs-content-list": _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPlanOperators, (data) => {
                      return (_openBlock(), _createElementBlock("div", { key: data }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(data[0]), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data[1], (carrier) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: carrier.name,
                            class: "plan-carriers-list--item mb-2"
                          }, [
                            _createElementVNode("label", {
                              for: carrier.id,
                              class: "row py-2"
                            }, [
                              _createElementVNode("span", _hoisted_9, [
                                _createVNode(_component_Partner, {
                                  name: carrier.name,
                                  title: carrier.title,
                                  image: carrier.image
                                }, null, 8, ["name", "title", "image"])
                              ]),
                              _createElementVNode("span", _hoisted_10, [
                                _createVNode(_component_AppCheckbox, {
                                  id: carrier.id,
                                  "model-value": carrier.active,
                                  "is-delay": true,
                                  "onUpdate:modelValue": ($event: any) => (
                            _ctx.isOperatorChecked(carrier.id, carrier.active)
                          )
                                }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
                              ])
                            ], 8, _hoisted_8)
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", {
                    for: `plan-${_ctx.id}-free-socials`,
                    class: "d-flex align-items-center justify-content-between cursor-pointer"
                  }, [
                    _hoisted_13,
                    _createVNode(_component_AppCheckbox, {
                      id: `plan-${_ctx.id}-free-socials`,
                      modelValue: _ctx.freeSocials,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.freeSocials) = $event))
                    }, null, 8, ["id", "modelValue"])
                  ], 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_AppSelectInput, {
                    id: "discount-type",
                    label: "Discount Type",
                    options: _ctx.mappedDiscounts,
                    onSelect: _ctx.discountSelect
                  }, null, 8, ["options", "onSelect"]),
                  _hoisted_15,
                  (_ctx.discountAvailable)
                    ? (_openBlock(), _createBlock(_component_AppSelectInput, {
                        key: 0,
                        id: "discount-amount",
                        label: "Discount Amount",
                        options: _ctx.mappedDiscountsAmount,
                        onSelect: _ctx.discountAmountSelect
                      }, null, 8, ["options", "onSelect"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_AppSelectInput, {
                    id: "esimType",
                    label: "Esim Types",
                    disabled: _ctx.isDisabled,
                    options: _ctx.mappedType,
                    onSelect: _ctx.esimTypeSelect
                  }, null, 8, ["disabled", "options", "onSelect"]),
                  _hoisted_17,
                  _createVNode(_component_AppSelectInput, {
                    id: "esimServers",
                    label: "Esim Servers",
                    disabled: _ctx.isDisabled,
                    options: _ctx.mappedServers,
                    onSelect: _ctx.esimServerSelect
                  }, null, 8, ["disabled", "options", "onSelect"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_AppSelectInput, {
                    id: "esimZones",
                    label: "Esim Zones",
                    options: _ctx.mappedZone,
                    onSelect: _ctx.planZoneSelect
                  }, null, 8, ["options", "onSelect"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "tabs"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}